import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignKeywordParams from './CampaignKeywordParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignKeywordParams = connect(
  mapStateToProps, null,
)(CampaignKeywordParams);

export default withTranslation(['administration'])(ConnectedCampaignKeywordParams as any);
